module.exports = __webpack_public_path__ + "media/mem_coin.2ee8e30e.mp4";